/**
 * @module
 * @name Spinner
 * @description Spinner
 */
export default {
  name: 'Spinner',
  props: {
    size: {
      type: String,
      default: 'normal',
      required: false
    }
  }
}
